import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Input } from '.'

function toDate (value) {
  if (!value) return null
  const s = String(value).trim()
  const parts = s.split(':')
  const h = parseInt(parts[0], 10) || 0
  const m = parseInt(parts[1], 10) || 0
  const sec = parseInt(parts[2], 10) || 0
  return new Date(1970, 0, 1, h, m, sec)
}

function fromDate (date) {
  if (!date) return ''
  const h = date.getHours().toString().padStart(2, '0')
  const m = date.getMinutes().toString().padStart(2, '0')
  const s = date.getSeconds().toString().padStart(2, '0')
  return `${h}:${m}:${s}`
}

export default ({ placeholder, size, value, disabled, onChange }) => {
  const selected = toDate(value)
  return (
    <DatePicker
      placeholderText={placeholder ?? 'Select a time...'}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeCaption='Time'
      dateFormat='HH:mm'
      selected={selected}
      disabled={disabled}
      onChange={(date) => onChange(date ? fromDate(date) : '')}
      customInput={<Input size={size} disabled={disabled} />}
    />
  )
}
